import en from "../../messages/en.json";
import hi from "../../messages/hi.json";
import { NextIntlClientProvider } from "next-intl";
import type { AppLocale } from "@lms/backend/lib/i18n/locale";

const MESSAGES: Record<AppLocale, typeof en> = { en, hi };

type IntlProviderProps = {
  locale: AppLocale;
  children: React.ReactNode;
};

export function IntlProvider({ locale, children }: IntlProviderProps) {
  return (
    <NextIntlClientProvider locale={locale} messages={MESSAGES[locale]}>
      {children}
    </NextIntlClientProvider>
  );
}
